import { isFinite } from 'lodash'
import { ReactElement } from 'react'
import { FormattedMessage } from 'react-intl'
import { NavLink } from 'react-router-dom'
import styled from 'styled-components'

// @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
import { PlusIcon } from '@10xLabs/react-web/components/Icons/Plus'
import List from 'components/v2/List'
import { FormattedDuration } from '@10xLabs/react-web/components/FormattedDuration'
import { FormattedRoute } from '@10xLabs/react-web/components/FormattedRoute'
import { Dropdown } from 'components/v2/Dropdown'
import { DotsIcon } from 'components/Icons/DotsIcon'
import { StyledLink } from 'components/v2/Link'
import { TableContainer, Table, Thead, Th, Tbody, Tr, Td } from 'components/v2/Table'
import { FormattedDistance } from 'components/FormattedDistance'
import { FEATURES } from 'features/Roles/components/Permissions/constants'
import { canWrite, isSuperAdmin } from 'features/Users/utils'
import IconButton from 'components/v2/IconButton'
import { GTSegment } from 'gql/types.generated'
import { useLogin } from 'features/Login/hooks'

const PlusIconWrapper = styled.div<TSFixMe>`
  display: inline;
  cursor: pointer;

  svg {
    fill: #5d59d7;
  }
`

export const SegmentsList = ({ segments = [] }: { segments: GTSegment[] }): ReactElement => {
  const login = useLogin()

  const showCompany = isSuperAdmin(login.accessToken.conditions)
  const canUpdateFareFamilies = canWrite(FEATURES.FARE_FAMILY, login.accessToken.policies)

  return (
    <TableContainer overflow>
      <Table marginBottom>
        <Thead>
          <Tr>
            {canWrite(FEATURES.SEGMENT, login.accessToken.policies) && <Th />}
            <Th>
              <FormattedMessage id="dictionary.segment" defaultMessage="Segment" />
            </Th>
            <Th>
              <FormattedMessage id="dictionary.duration" defaultMessage="Duration" />
            </Th>
            <Th>
              <FormattedMessage id="dictionary.distance" defaultMessage="Distance" />
            </Th>
            <Th>
              <FormattedMessage id="dictionary.line" defaultMessage="Line" />
            </Th>
            {showCompany && (
              <Th>
                <FormattedMessage id="dictionary.company" defaultMessage="Company" />
              </Th>
            )}
            {canUpdateFareFamilies && <Th />}
          </Tr>
        </Thead>
        <Tbody>
          {segments.map((segment: TSFixMe): ReactElement => {
            return (
              <Tr key={segment.id}>
                {canWrite(FEATURES.SEGMENT, login.accessToken.policies) && (
                  <Td>
                    <Dropdown
                      toggle={<IconButton icon={<DotsIcon />} noBorder smallPadding />}
                      noPadding
                      noIndicator
                      left
                    >
                      <List.Container>
                        <List.Item noPadding>
                          <List.Link to={`/segments/${segment.id}`}>
                            <FormattedMessage id="segments.list.actions.edit" defaultMessage="Edit segment" />
                          </List.Link>
                        </List.Item>
                      </List.Container>
                    </Dropdown>
                  </Td>
                )}
                <Td>
                  <FormattedRoute origin={segment.origin} destination={segment.destination} showCode />
                </Td>
                <Td>
                  {segment.duration ? (
                    <FormattedDuration duration={segment.duration} />
                  ) : canWrite(FEATURES.SEGMENT, login.accessToken.policies) ? (
                    <PlusIconWrapper as={NavLink} to={`/segments/${segment.id}`}>
                      <PlusIcon />
                    </PlusIconWrapper>
                  ) : (
                    '-'
                  )}
                </Td>
                <Td>
                  {isFinite(segment.distance) ? (
                    <FormattedDistance distance={segment.distance} />
                  ) : canWrite(FEATURES.SEGMENT, login.accessToken.policies) ? (
                    <PlusIconWrapper as={NavLink} to={`/segments/${segment.id}`}>
                      <PlusIcon />
                    </PlusIconWrapper>
                  ) : (
                    '-'
                  )}
                </Td>
                <Td>
                  {segment.companyLineSpecs.length > 0 ? (
                    <Dropdown toggle={<StyledLink>{segment.companyLineSpecs.length}</StyledLink>} noPadding>
                      <List.Container>
                        {segment.companyLineSpecs.map(({ companyLine }: TSFixMe): TSFixMe => {
                          return <List.Item key={companyLine.id}>{companyLine.name}</List.Item>
                        })}
                      </List.Container>
                    </Dropdown>
                  ) : (
                    0
                  )}
                </Td>
                {showCompany && <Td>{segment.company.name}</Td>}
                {canUpdateFareFamilies && (
                  <Td>
                    <StyledLink as={NavLink} to={`/fare-families?segmentId=${segment.id}`}>
                      <FormattedMessage id="segments.list.actions.fareFamilies" defaultMessage="Link" />
                    </StyledLink>
                  </Td>
                )}
              </Tr>
            )
          })}
        </Tbody>
      </Table>
    </TableContainer>
  )
}
